// axios
import axios from "axios";
import store from "@/store/index";

const instance = axios.create({
  baseURL: process.env.VUE_APP_DOMAIN,
  // You can add your headers here
});

instance.interceptors.request.use(
  function(config) {
    const token = store.getters["auth/getuser"]["accessToken"];
    if (token != null) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function(err) {
    return Promise.reject(err);
  }
);

export default instance;
